<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>运行数据</a-breadcrumb-item>
				<a-breadcrumb-item>停靠统计</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<!-- <a-button class="qinang-button-margin" icon="plus" @click="addVisible = true">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button> -->
				<a-button icon="sync" @click="apiCompanyQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="条件查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">设备名称：</div>
						<a-input v-model="query.companyName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">开始时间：</div>
						<a-date-picker v-model="query.startTime" style="width: 100%;" format="YYYY-MM-DD"/>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">截止时间：</div>
						<a-date-picker v-model="query.startTime" style="width: 100%;" format="YYYY-MM-DD"/>
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
					<a-button type="primary" icon="search" @click="apiCompanyQueryList">查询</a-button>
					<a-button icon="redo" @click="resetChange" style="margin-left: 14px;">重置</a-button>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="companyId" :loading="tableLoading" :pagination="false">
				<span slot="companyName" slot-scope="companyName">
					<a-button type="link" @click="edit(companyName)" >{{companyName.companyName}}</a-button>
				</span>
				<span slot="companyState" slot-scope="companyState">
					<span v-if="companyState == 2">禁用</span>
					<span v-if="companyState == 3">启用</span>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->		
		<a-modal title="添加" width="60%" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="addVisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="设备名称" has-feedback prop="companyName">
					<a-input v-model="addForm.companyName" placeholder="请输入名称" />
				</a-form-model-item>
				<a-form-model-item label="维修单位" has-feedback prop="companyHead">
					<a-input v-model="addForm.companyHead" placeholder="请输入维修单位" />
				</a-form-model-item>
				<a-form-model-item label="维修时间" has-feedback prop="companyHead">
					<a-date-picker v-model="addForm.startTime" format="YYYY-MM-DD"/>
				</a-form-model-item>
				<a-form-model-item label="描述" has-feedback prop="companyTel">
					<a-textarea placeholder="在这里输入备注" :rows="6" v-model="addForm.remarks" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal title="修改" width="60%" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editVisible = false"  :maskClosable="false" :keyboard="false">
			<a-form-model style="" ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="企业名称" has-feedback prop="companyName">
					<a-input v-model="editForm.companyName" placeholder="请输入企业名称" />
				</a-form-model-item>
				<a-form-model-item label="联系人" has-feedback prop="companyHead">
					<a-input v-model="editForm.companyHead" placeholder="请输入联系人姓名" />
				</a-form-model-item>
				<a-form-model-item label="联系电话" has-feedback prop="companyTel">
					<a-input v-model="editForm.companyTel" placeholder="请输入联系电话" />
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="companyState">
					<a-radio-group name="companyState" v-model="editForm.companyState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					companyName: '',
					startTime: moment(),
					endTime: moment(),
				},
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'companyId', key:'companyId', align:'center'},
					{ title:'设备名称', key:'companyName', align:'center', scopedSlots:{customRender:'companyName'}},
					{ title:'楼层', key:'companyHead', dataIndex:'companyHead', align:'center'},
					{ title:'刷卡次数', key:'companyTel', dataIndex:'companyTel',align:'center'},
				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					companyName: '',
					companyHead: '',
					companyTel: '',
					companyState: 3,
				},
				addRules: {
					companyName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
					companyState: [{ required: true, message: '请选择', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					companyId: '',
					companyName: '',
					companyHead: '',
					companyTel: '',
					companyState: 3,
				},
				// 修改弹窗-end
			};
		},
		methods: {
			//重置
			resetChange() {
				this.query = {
					page: 1,
					size: 10,
					total: 0,
					companyName: '',
				}
			},
			//表格开始-搜索
			async apiCompanyQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCompanyQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiCompanyQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiCompanyQueryList()
			},
			async apiCompanyAdd() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCompanyAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiCompanyQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.addVisible = false
				// this.$refs.addRuleForm.validate(valid => {
				// 	if (valid) {
				// 		this.apiCompanyAdd()
				// 	} else {
				// 	  return false;
				// 	  this.addConfirmLoading = true
				// 	}
				// });
				
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))
				this.editForm = items
				this.editVisible = true
			},
			async apiCompanyEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCompanyEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiCompanyQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiCompanyEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.companyId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.companyName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiCompanyDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiCompanyDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCompanyDel, {companyId: this.tableSelectedRows.companyId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiCompanyQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			tableEdit() {
				if(this.tableSelectedRows.companyId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			// this.apiCompanyQueryList()
		}
	};
</script>

<style scoped>
	.qinang-search-col-3 .ant-input{
		width: 100%;
	}
</style>
